<template>
    <StandardDropdown
        :modelValue="selectedDatabase"
        :options="databaseOptions"
        id="database-selector"
        class="multiselect-custom"
        checkmark
        @change="selectDatabase($event)"
    />
</template>

<script>
import StandardDropdown from '@/components/common/StandardDropdown.vue';

export default {
    name: 'DatabaseSelector',
    props: ['selectedDatabase', 'databaseOptions'],
    components: {
        StandardDropdown,
    },
    methods: {
        selectDatabase(event) {
            this.$emit('handleSelectedDatabase', event);
        },
    },
};
</script>
